import { apiService } from '../api.service';

import type { IHeadOffice } from '@/interfaces/business';

const BusinessResources = {
  head_office: () => apiService.get<IHeadOffice>('v1/hr_managers/me/head_office'),
};

export default BusinessResources;
